import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash/fp';
import qs from 'query-string';
import Cookies from 'js-cookie';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '@material-ui/core';

import { Spinner } from '../../../components';
import { CLASSTING_AUTH_URL, CLASSTING_CLIENT_ID } from '../../../constants';
import * as actions from '../actions';
import { closeWebView, getTokenFromNative, isWebView } from '../../../utils';

const AuthCallback = ({ location, history }) => {
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const accessToken = useSelector((state) => state.auth.accessToken);
  const error = useSelector((state) => state.auth.error);

  const dispatch = useDispatch();

  const handleCloseErrorDialog = useCallback(() => {
    if (isWebView()) {
      closeWebView();
    } else {
      history.goBack();
    }
    setErrorDialogOpen(false);
    dispatch(actions.initError());
  }, [dispatch, history]);

  const authorize = useCallback(() => {
    const authParams = qs.stringify({
      client_id: CLASSTING_CLIENT_ID,
      response_type: 'id_token token',
      scope: 'openid email profile',
      nonce: Math.random().toString(36).substring(10),
      redirect_uri: `${window.location.origin}${location.pathname}`,
    });

    window.location.replace(`${CLASSTING_AUTH_URL}/auth?${authParams}`);
  }, [location]);

  const setCallbackForToken = useCallback(() => {
    window.setToken = (token) => {
      dispatch(actions.setAuthRequest({ accessToken: token }));
    };
    getTokenFromNative();
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      setErrorDialogOpen(true);
    }
  }, [error]);

  useEffect(() => {
    if (isWebView()) {
      setCallbackForToken();
      return;
    }

    const params = qs.parse(location.hash);
    const savedAccessToken = Cookies.get('access_token');

    if (!isEmpty(params) || savedAccessToken) {
      dispatch(actions.setAuthRequest({ accessToken: params.access_token || savedAccessToken }));
    } else {
      authorize();
    }
  }, [location.hash, dispatch, setCallbackForToken, authorize]);

  const redirect = () => {
    const redirectUrl = Cookies.get('redirect_url');
    const { pathname, search } = qs.parse(redirectUrl);

    return (
      <Redirect
        to={{
          pathname: pathname || '/',
          search: search || '',
          state: { from: pathname || '/' },
        }}
      />
    );
  };

  return accessToken ? redirect()
    : (
      <>
        {!error && <Spinner />}
        <Dialog
          onClose={handleCloseErrorDialog}
          open={errorDialogOpen}
        >
          <DialogContent>
            에러가 발생했습니다. 앱을 종료하고 다시 실행해주세요.
          </DialogContent>
          <DialogActions>
            <Button type="button" color="secondary" onClick={handleCloseErrorDialog}>확인</Button>
          </DialogActions>
        </Dialog>
      </>
    );
};

AuthCallback.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    state: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};


export default AuthCallback;
